<template>
  <Transition name="radial-vue-radial-menu-item">
    <div
      :style="style"
      class="vue-radial-menu-item"
      @click="handleClick"
    >
      <slot />
    </div>
  </Transition>
</template>

<script>
// author: vparadis
// repo: https://github.com/vparadis/vue-radial-menu

// eslint-disable

export default {
  name: 'RadialMenuItem',
  props: {
    top: {
      type: Number,
      required: true,
    },
    left: {
      type: Number,
      required: true,
    },
    height: {
      type: Number,
      required: true,
    },
    width: {
      type: Number,
      required: true,
    },
    onClick: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    const {
      top, left, height, width,
    } = this;
    return {
      style: {
        top: `${top}px`,
        left: `${left}px`,
        width: `${width}px`,
        height: `${height}px`,
      },
    };
  },
  methods: {
    handleClick(e) {
      if (this.onClick) this.onClick(e);
      this.$emit('click', e);
    },
  },
};
</script>

<style>
.vue-radial-menu-item {
  position: absolute;
  border-radius: 50%;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s ease;
  transform: none;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.24), 0 0 0 rgba(0, 0, 0, 0.16);
  user-select: none;
  font-size: 16px;
  z-index: 7;
}

.vue-radial-menu-item:hover {
  z-index: 8;
}

.radial-vue-radial-menu-item-enter,
.radial-vue-radial-menu-item-leave-to {
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%);
  opacity: 0;
}
</style>
